import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { SolutionsSection } from '../components/SolutionsSection';
import { PricingSection } from '../components/PricingSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-778" />
      <ServicesSection data-id="element-779" />
      <SolutionsSection data-id="element-780" />
      <PricingSection data-id="element-781" />
    </>;
}